"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFrameDrPicasoDev = exports.loadFrameDrPicaso = exports.loadFrame = exports.loadFrameDev = exports.loadHybridFrame = void 0;
const frame_renderizers_1 = require("./frame.renderizers");
const loadHybridFrame = async (config, setFramework) => {
    // if (isWebViewPlatform()) {
    (0, frame_renderizers_1.initializeHybridFrame)(config, setFramework);
    // } else {
    //   initializeFrame(config, setFramework);
    // }
};
exports.loadHybridFrame = loadHybridFrame;
const loadFrameDev = async (config, setFramework) => {
    (0, frame_renderizers_1.initializeDevelopmentFrame)(config, setFramework);
};
exports.loadFrameDev = loadFrameDev;
const loadFrame = async (config, setFramework) => {
    (0, frame_renderizers_1.initializeFrame)(config, setFramework);
};
exports.loadFrame = loadFrame;
const loadFrameDrPicaso = async (config, setFramework) => {
    (0, frame_renderizers_1.initializeDrPicasoFrame)(config, setFramework);
};
exports.loadFrameDrPicaso = loadFrameDrPicaso;
// export const loadFrameDev = async (config: FrameConfigBase, setFramework: setWebFrameworkParamsType): Promise<void> => {
//   initializeDevelopmentFrame(config, setFramework);
// };
const loadFrameDrPicasoDev = async (config, setFramework) => {
    (0, frame_renderizers_1.initializeDrPicasoDevelopmentFrame)(config, setFramework);
};
exports.loadFrameDrPicasoDev = loadFrameDrPicasoDev;
//# sourceMappingURL=frame.loader.js.map